import { useForm } from "@shared/features/form/useForm";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { SignupForm } from "./SignupForm";
import { baseSignupSchema } from "../../auth.schemas";
import useTrackSignupEvents from "../../hooks/useTrackSignupEvents";
import useSignupMutation from "../../hooks/useSignupMutation";
import useGoogleSignupMutation from "../../hooks/useGoogleSignupMutation";
import { Invitation } from "@platform/types/platform.types";

type Props = {
  className?: string;
  invitation: Invitation;
  onError?: () => void;
  onSuccess?: (data: any) => void;
  isWithAdditionalContent?: boolean;
};

export function SignupContainer({
  className,
  invitation,
  onError,
  onSuccess,
  isWithAdditionalContent = true,
}: Props) {
  const schema = baseSignupSchema;

  const fields = makeFormFields([
    "firstName",
    "lastName",
    "email",
    "confirmEmail",
    "password",
  ]).map((field) => {
    if (field.name === "email" || field.name === "confirmEmail") {
      return { ...field, autoComplete: "username" };
    }

    if (field.name === "password" || field.name === "confirmEmail") {
      return { ...field, autoComplete: "new-password" };
    }
    return field;
  });

  const signupMutation = useSignupMutation({
    invitation,
    onSuccess,
    schema,
    onError,
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: signupMutation.mutateAsync,
  });

  const googleSignupMutation = useGoogleSignupMutation({
    invitation,
    onError,
    onSuccess,
    schema,
    form,
  });

  // Track signup intent and signup started events
  useTrackSignupEvents({ invitation, watch: form.watch });

  return (
    <SignupForm
      fields={fields}
      form={form}
      className={className}
      isWithAdditionalContent={isWithAdditionalContent}
      onSignup={handleSubmit}
      onSignupWithGoogle={googleSignupMutation.mutateAsync}
    />
  );
}

export default SignupContainer;
